import {Component, CUSTOM_ELEMENTS_SCHEMA, inject, OnInit} from '@angular/core';
import {Router, RouterLink} from '@angular/router';
import {NgbCollapseModule, NgbDropdown, NgbDropdownMenu, NgbDropdownToggle, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {CommonModule} from '@angular/common';
import {NgIcon} from '@ng-icons/core';
import {userDropdownItems, UserDropdownItemType} from '@layouts/components/data';
import { AuthService } from '@core/services/auth.service';
import { ResetPasswordComponent } from '@app/components/reset-password/reset-password.component';
import { environment } from '@/environments/environment';

@Component({
  selector: 'app-user-profile',
  imports: [
    RouterLink,
    NgbCollapseModule,
    NgbDropdown,
    NgbDropdownToggle,
    NgbDropdownMenu,
    CommonModule,
    NgIcon
  ],

  templateUrl: './user-profile.component.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class UserProfileComponent implements OnInit {
  menuItems: (UserDropdownItemType & { action?: () => void })[] = [];
  user: any;
  roles: string = '';
  private modal_svc=inject(NgbModal)
  private isTest = !environment.production;
  constructor(
    private authService: AuthService,
    private router: Router
  ) {
    const actions: Record<string, () => void> = {
      logout: () => this.logout(),
      changepass:()=>this.changepass()
    };
    this.menuItems = userDropdownItems.map(item => ({
      ...item,
      action: item.actionKey ? actions[item.actionKey] : undefined
    }));
  }

  ngOnInit(): void {
    this.authService.getCurrentUser().subscribe(user => {
      this.user = user;
    });
    this.roles = this.authService.getRolesLabel();
    if(this.isTest) console.log('user-profile this.user', this.user);
    if(this.isTest) console.log('user-profile this.roles', this.roles);
  }

  logout() {
    this.authService.logout();
  }
  changepass(){
    const ref=this.modal_svc.open(ResetPasswordComponent)
    ref.closed.subscribe((rs)=>{
      if(rs){
        this.logout();
      }
    })
  }
}
